import { GridItemNormalizer } from '../types';

export default class StatusApplicationObjectNormalizer implements GridItemNormalizer {
  support(value: any): boolean {
    return value?.__typename === 'object_StatusApplication';
  }

  normalize(value: any) {
    return value?.Status;
  }

  normalizeAsSelectValue(value: any) {
    return this.normalize(value);
  }

  getRequiredFields() {
    return {
      id: '',
      name: '',
      code: '',
    };
  }
}
